import { useMutation, useQueryClient } from '@tanstack/react-query';

import { productsApi } from '../api/products-api';

import { productKeys } from './product-keys';

/**
 * Deletes the product and takes it out of every store in one go. The delete modal explains a
 * refusal: an auction or rotation holding it (409 RESOURCE_IN_USE), a store the person cannot
 * write to (403) or a closed store (409 STORE_READ_ONLY).
 */
export function useDeleteProduct() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (productId: string) => productsApi.remove(productId, { removeFromStores: true }),
    meta: { successMessage: 'products:toasts.deleted', silentError: true },
    onSuccess: (_void, productId) => {
      queryClient.removeQueries({ queryKey: productKeys.detail(productId) });
      return Promise.all([
        queryClient.invalidateQueries({ queryKey: productKeys.lists() }),
        queryClient.invalidateQueries({ queryKey: productKeys.vendors() }),
      ]);
    },
  });
}
